/*
 * Public API Surface of angular
 */

export * from './lib/skeleton-elements.module';
export * from './lib/skeleton-block';
export * from './lib/skeleton-avatar';
export * from './lib/skeleton-text';
export * from './lib/skeleton-image';
export * from './lib/skeletonEffect';
